(function ( $ ) {
 
    $.multiStateCheck = function (element, options) {

        var defaults = {
            states: ["crossed", "unchecked", "checked"],
            onAfterChangeState: function () { },
        }

        var plugin = this;

        plugin.settings = {}

        var $element = $(element),
            element = element;

        plugin.init = function () {
            plugin.settings = $.extend({}, defaults, options);

            $element.off("click").on("click", function (e) {

                if ($(this).attr("disabled")) {
                    return;
                }

                // three-way state
                //switch ($(this).attr("data-state")) {
                //    case "checked":
                //        $(this).attr("data-state", "crossed");
                //        break;
                //    case "crossed":
                //        $(this).attr("data-state", "unchecked");
                //        break;
                //    default: /* unchecked */
                //        $(this).attr("data-state", "checked");
                //}

                var currentState = $(this).attr("data-state");
                var indexCurrentState = options.states.indexOf(currentState);
                var nextState = indexCurrentState == options.states.length - 1 ? 0 : indexCurrentState + 1; // either choose the next state, or if we are at the last state, choose the first state
                $(this).attr("data-state", options.states[nextState])

                if (options.onAfterChangeState !== undefined) {
                    options.onAfterChangeState(e);
                }
            });

        }

        plugin.revert = function () {
            if ($element.attr("disabled")) {
                return;
            }
            console.log("Reverting");
            // three-way state
            //switch ($element.attr("data-state")) {
            //    case "checked":
            //        $element.attr("data-state", "unchecked");
            //        break;
            //    case "crossed":
            //        $element.attr("data-state", "checked");
            //        break;
            //    default:
            //        $element.attr("data-state", "crossed");
            //}

            var currentState = $element.attr("data-state");
            var indexCurrentState = options.states.indexOf(currentState);
            var nextState = 0 ? options.states.length - 1 : indexCurrentState - 1; // either choose the previous state, or if we are at the first state, choose the last state
            $element.attr("data-state", options.states[nextState])
        }

        plugin.init(); 
    }

    $.fn.multiStateCheck = function (options) {

        return this.each(function () {
            if ($(this).data('multiStateCheck') == undefined) {
                var plugin = new $.multiStateCheck(this, options);
                $(this).data('multiStateCheck', plugin);
            }
        });
    }
}(jQuery));


